(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-shipping-note"] && !Shopify.designMode) return;
  try {
    (function () {
    // Atributos propios: product-tabs engancha todo lo que lleve
    // data-open-modal, y compartirlos abriría el diálogo dos veces.
    document.querySelectorAll('[data-open-shipping-note]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = document.getElementById(trigger.getAttribute('data-open-shipping-note'));
        if (modal && !modal.open) modal.showModal();
      });
    });

    document.querySelectorAll('.product-shipping-note__modal').forEach(function (modal) {
      var closeButton = modal.querySelector('[data-close-shipping-note]');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          modal.close();
        });
      }

      // Pulsar fuera cierra; Esc lo gestiona <dialog> por su cuenta
      modal.addEventListener('click', function (event) {
        if (event.target === modal) modal.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
